import { render, staticRenderFns } from "./FormCredential.vue?vue&type=template&id=480d3b11&scoped=true&"
import script from "./FormCredential.vue?vue&type=script&lang=js&"
export * from "./FormCredential.vue?vue&type=script&lang=js&"
import style0 from "./FormCredential.vue?vue&type=style&index=0&id=480d3b11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480d3b11",
  null
  
)

export default component.exports